import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ItemArticle from '../../../../topics/Article/components/ItemArticle'

const BlockArticles = ({ data: { articles }, ...props }) => {
  return (
    <Fragment {...props}>
      {articles.map((item, index) => (
        <ItemArticle key={'ItemArticle' + index} view="small_landscape" article={item} />
      ))}
    </Fragment>
  )
}

BlockArticles.propTypes = {
  articles: PropTypes.arrayOf(ItemArticle.propTypes.article),
}

export default BlockArticles
